<app-header></app-header>

<!-- loader -->
        <div id="global-loader" [style.display]="!isLoading ? 'block' : 'none'">
            <img src="assets/images/loader.svg" class="loader-img " alt="">
        </div>
<!-- /loader -->

<!--Breadcrumb-->
        <div>
            <div class="bannerimg cover-image bg-background3 car-detail-header" data-image-src="assets/images/banners/banner2.jpg">
                <div class="header-text mb-0">
                    <div class="container">
                        <div class="text-center text-white ">
                            <h2 class="mb-0">Want to get in touch? We'd love to hear from you.</h2>
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--/Breadcrumb-->

        <!--Contact-->
        <div class="sptb bg-white mb-0">
            <div class="container">
                <div class="row">
                    <div class="col-lg-5 col-xl-4 col-md-12">
                        <div class="contact-description">
                            <h2 class="header-con">Interseted in OKSHAN Services ? </h2>
                            <p class="mt-5"> Don’t worry… we’re here for you. Just pick up the phone to call our sales team or write us .</p>

                            <div class="mb-5">
                                <small class="text-muted">Need Help?</small>
                                <p class="mb-0 fs-16 font-weight-bold">info@okshan.com</p>
                            </div>
                            <div class="mb-5">
                                <small class="text-muted">Feel Like Talking?</small>
                                <p class="mb-0 fs-16 font-weight-bold">+91 804413429</p>
                            </div>
                            <small class="text-muted">Social Share</small>
                            <ul class="list-unstyled list-inline mt-3 mb-5">
                                <li class="list-inline-item">
                                    <a class="btn-floating btn-sm rgba-white-slight mx-1 waves-effect waves-light">
                                        <i class="fa fa-facebook bg-facebook"></i>
                                    </a>
                                </li>
                                <li class="list-inline-item">
                                    <a class="btn-floating btn-sm rgba-white-slight mx-1 waves-effect waves-light">
                                        <i class="fa fa-twitter bg-info"></i>
                                    </a>
                                </li>
                                <li class="list-inline-item">
                                    <a class="btn-floating btn-sm rgba-white-slight mx-1 waves-effect waves-light">
                                        <i class="fa fa-google-plus bg-danger"></i>
                                    </a>
                                </li>
                                <li class="list-inline-item">
                                    <a class="btn-floating btn-sm rgba-white-slight mx-1 waves-effect waves-light">
                                        <i class="fa fa-linkedin bg-linkedin"></i>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-lg-7 col-xl-8 col-md-12">
                        <div class="single-page" >
                            <div class="col-lg-12 col-md-12 mx-auto d-block">
                                <div class="wrapper wrapper2">
                                    <div class="card box-shadow-0 mb-0">
                                        <div class="card-body">
                                            <form [formGroup]="visitorContactUsFormGroup" (ngSubmit)="proceedContactUsRequest(visitorContactUsFormGroup.value)">
                                            <div class="form-group">
                                                <div style="">
                                                <input formControlName="visitorContactUsName" type="text" class="form-control" id="name1" placeholder="Your Name*">
                                                </div>
                                                <div *ngIf="visitorContactUsFormGroup.get('visitorContactUsName').errors && (visitorContactUsFormGroup.controls.visitorContactUsName.dirty || visitorContactUsFormGroup.controls.visitorContactUsName.touched || isSubmit)">
                                                <span style="color:red">Enter name</span>
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <div style="">
                                                <input formControlName="visitorContactUsEmail" type="email" class="form-control" id="email" placeholder="Email Address*">
                                                </div>
                                                <div *ngIf="visitorContactUsFormGroup.get('visitorContactUsEmail').errors && (visitorContactUsFormGroup.controls.visitorContactUsEmail.dirty || visitorContactUsFormGroup.controls.visitorContactUsEmail.touched || isSubmit)">
                                                <div *ngIf="visitorContactUsFormGroup.get('visitorContactUsEmail').hasError('required')">
                                                <span style="color:red">Enter email</span>
                                                </div>
                                                <div *ngIf="visitorContactUsFormGroup.get('visitorContactUsEmail').hasError('pattern')">
                                                <span style="color:red">Enter valid email</span>
                                                </div>
                                                </div>
                                            </div>
                                            <div class="form-group">
                                            <div id="mobile_no" class="mail">
                                            <div style="display:flex">
                                            <input style="" type="text" value="+91" readonly  class="form-control widthinput">
                                            <input style="" formControlName="visitorContactUsMobileNo" type="text"  class="form-control widthinput1" placeholder="Enter Mobile No.">
                                            </div>
                                          
                                        </div>
                                        <div *ngIf="visitorContactUsFormGroup.get('visitorContactUsMobileNo').errors  && (visitorContactUsFormGroup.controls.visitorContactUsMobileNo.dirty || visitorContactUsFormGroup.controls.visitorContactUsMobileNo.touched || isSubmit)">  
                                        <div *ngIf="visitorContactUsFormGroup.get('visitorContactUsMobileNo').hasError('required')">  
                                            <span style="color: red;">Enter mobile no.</span>  
                                        </div>  
                                        <div *ngIf="visitorContactUsFormGroup.get('visitorContactUsMobileNo').hasError('pattern') || visitorContactUsFormGroup.get('visitorContactUsMobileNo').hasError('maxlength')">  
                                            <span style="color: red;">Enter 10 digit valid mobile no.</span>  
                                        </div> 
                                        </div>
                                        </div>
                                            <div class="form-group">
                                                <div >
                                                <textarea formControlName="visitorContactUsMessage" class="form-control" name="example-textarea-input" rows="6" placeholder="Message*"></textarea>
                                                </div>
                                                <div *ngIf="visitorContactUsFormGroup.get('visitorContactUsMessage').errors && (visitorContactUsFormGroup.controls.visitorContactUsMessage.dirty || visitorContactUsFormGroup.controls.visitorContactUsMessage.touched || isSubmit)">
                                                <span style="color:red">Enter message</span>
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <div _ngcontent-qok-c1="" style="color: black;">
                                                    <span style="float:left;font-size: 11px;text-align: left;padding: 6px;"> 
                                                        <input _ngcontent-qok-c1="" _ngcontent-iir-c1="" class="form-control" id="authorization"formControlName="visitorContactUsterm" style="height: 15px;
                                                    padding: 5px 10px;
                                                    width: 3%; float:left;
                                                    /* border: soli" type="checkbox"> I, hereby authorize Sanch Motor Pvt Ltd., to contact me.By providing your contact details you have expressly authorized MDPL to contact you in future through calls / SMS / E-mails and inform you about our products. </span></div>
                                                <div *ngIf="visitorContactUsFormGroup.get('visitorContactUsterm').errors && (visitorContactUsFormGroup.controls.visitorContactUsterm.dirty || visitorContactUsFormGroup.controls.visitorContactUsterm.touched || isSubmit)">
                                                <span style="color:red"> You must agree to the terms and conditions before proceeding.</span>
                                                </div>
                                            </div>
                                            I, hereby authorize Sanch Motor Pvt Ltd., to contact me.By providing your contact details you have expressly authorized MDPL to contact you in future through calls / SMS / E-mails and inform you about our products. 
                                            
                                            <button [disabled]="requestInProcess" class="btn btn-primary">Send Message</button>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--Contact-->
        <app-footer></app-footer>